import React, { FC, useEffect, useState } from 'react';
import { Box } from '@mui/system';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import { CircularProgress, IconButton, Typography } from '@mui/material';
import { Icon } from '@iconify/react';
import { useParams } from 'react-router-dom';
import { getVehicleTeam } from '../../services/vehicles';
import TabLoader from './TabLoader';
import useMetaData from '../../hooks/useMetaData';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';
import { ReactComponent as EmptyAvatar } from '../../assets/icons/avatar.svg';

const TeamList = () => {
  // use hooks
  const { reservationId } = useParams<{ reservationId: string }>();
  const lucidTeamMetaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.lucidTeamTab);

  // local states
  const [team, setTeam] = useState<Array<any>>();
  const [loading, setLoading] = useState<boolean>(false);

  // handling render teams
  const renderTeam = (user: any) => {
    const {
      teamDetail: { image, name, role },
    } = lucidTeamMetaData as any;
    return (
      <ListItem
        sx={{ p: 1, my: 1, border: '1px solid #E3E3E3', borderRadius: '6px' }}
        key={user[name]}
        // secondaryAction={
        //   <IconButton size="small" edge="end" aria-label="delete">
        //     <Icon icon="ci:message-writing" color="#456BD9" />
        //   </IconButton>
        // }
      >
        <ListItemAvatar sx={{ minWidth: 'auto' }}>
          <Avatar src={user[image]} sx={{ width: '32px', height: '32px', marginRight: 1 }} />
        </ListItemAvatar>
        <ListItemText
          primary={user[name]}
          secondary={user[role]}
          primaryTypographyProps={{ sx: { fontSize: 16, fontWeight: 400, color: '#3E3E3E' } }}
          secondaryTypographyProps={{ sx: { fontSize: 14, fontWeight: 400, color: '#717171' } }}
        />
      </ListItem>
    );
  };

  // lifecycle hook
  useEffect(() => {
    if (reservationId) {
      setLoading(true);
      getVehicleTeam(reservationId)
        .then((response) => {
          setLoading(false);
          setTeam(response);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }, [reservationId]);

  if (loading || !lucidTeamMetaData)
    return (
      <Box sx={{ position: 'relative', minHeight: '250px' }}>
        <CircularProgress
          color="inherit"
          size={18}
          sx={{ position: 'absolute', left: '0', right: '0', top: '20%', margin: '0 auto' }}
        />
      </Box>
    );

  if (!team?.length)
    return (
      <Box alignItems="center" gap={1.75} display="flex" flexDirection="column" mt={2} mb={5} px={4}>
        <EmptyAvatar />
        <Box alignItems="center" gap={1.25} display="flex" flexDirection="column">
          <Typography fontSize={16} fontWeight={500} lineHeight="120%" color="black">
            Currently, the team is not assigned.
          </Typography>
          <Typography fontSize={14} fontWeight={500} lineHeight="130%" color="#A2A2A2" px={2} textAlign="center">
            The team members will appear here once they have been assigned
          </Typography>
        </Box>
      </Box>
    );

  return (
    <List sx={{ width: '100%', my: 1 }} dense disablePadding>
      {team?.map(renderTeam)}
    </List>
  );
};

export default TeamList;
